import React from 'react';
import MiCompBackground from '../../assets/img/Group 86.png';
import MiCompNewLogo2 from '../../assets/MiCompNewLogo2.png';
import MiCompBackground1 from '../../assets/img/Group.png';
import { Layout, Form, Input, Button, Card, Row, Col } from 'antd';
const { Content } = Layout;
class ConfirmPassForm extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isLoggingIn: false,
        IsActive: true,
      }
    }
    handleSubmit = (e) => {
      e.preventDefault();
      this.props.form.validateFields((err, values) => {
        if (!err) {
          this.setState({ isLoggingIn: true });
          this.props.handleAuthentication({ ...values, id: this.props.id });
        }
      });
    }
    render() {
      const { getFieldDecorator ,getFieldValue} = this.props.form;
      return (
        <Layout className="mi_comp_height100">
          <Content className="mi_app_background mi_comp_height100">
            <Row span={24} className="mi_comp_height100">

              <Col md={12} xs={24} className="mi_comp_height100">
                <Card align="center" className="mi_login_card" cover={<img alt="example" style={{ width: '120px',marginLeft:'-188px' }} src={MiCompNewLogo2} />} >
                 <div style={{marginLeft:'-10px'}}><Form onSubmit={this.handleSubmit} direction="vertical" align="center" className="login-form">


                    <Form.Item className="mi_input_login">
                    {getFieldDecorator('pass', {
                        rules: [{ required: true, message: 'Please enter your Password!' }],
                      })(
                        <Input.Password style={{ border: '1px solid black',borderRadius:'350px'  }} prefix={<i className="fa fa-lock" style={{ color: 'rgba(0,0,0,.25)' }} />} name="password"
                          type="password" placeholder="Password"  />
                      )}
                    </Form.Item>
                    <Form.Item className="mi_input_login">
                    {getFieldDecorator('password', {
                    rules: [{ required: true, message: 'Please confirm your password!' },
                    {
                      validator(rule,value) {
                        if (!value || getFieldValue('pass') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject('passwords that you entered do not match!');
                      }
                    }
                    ],
                  })(
                        <Input.Password style={{ border: '1px solid black',borderRadius:'350px'  }} prefix={<i className="fa fa-lock" style={{ color: 'rgba(0,0,0,.25)' }} />} name="password"
                          type="password" placeholder="Confirm Password" />
                      )}
                    </Form.Item>
                    <Form.Item>
                      <p className="mi_forget" style={{color:'darkslateblue'}} onClick={this.props.forget}>Forgot Password?</p>
                    </Form.Item>
                    <Form.Item>
                      <Button htmlType="submit" className="  mi_login_button"  style={{backgroundColor:'darkslateblue' ,border: '1px solid black' ,borderRadius:'350px',color:'white'}}>
                        Submit
                                </Button>
                    </Form.Item>
                  </Form>
                  </div>
                </Card>
              </Col>
              <Col md={12} xs={0} className="mi_comp_height1001 ">
                 <Card align="center" className="ant-input-rectang mi_login_card1" >

                   <p className='ant-text'>Welcome To MiComp</p>
                   <img className='ant-login-image' alt="example" style={{ width: '80px',float:'left',marginLeft: '15px'}} src={MiCompBackground1} />
                 <img className='ant-login-image' alt="example" style={{ width:'360px',bottom:'0',marginTop:'-47px'}} src={MiCompBackground} />
                </Card>
              </Col>
            </Row>
          </Content>
        </Layout>
      );
    }

  }
  export default ConfirmPassForm;